// extracted by mini-css-extract-plugin
module.exports = {"eye":"Eyes_eye__YOqu-","leftEye":"Eyes_leftEye__1l3js","rightEye":"Eyes_rightEye__19JPB","animate":"Eyes_animate__eIcYO","rotation":"Eyes_rotation__1OGkI"};